import { getDoctorDocuments } from "../../../Common/axios_instance/auth_https/auth.https";

export const fetchDoctorDocuments = (doctorId: string) => getDoctorDocuments(doctorId);
